import React from 'react';
import { SKILL_STATUS_BY_ALIAS, SKILL_STATUS } from '../constants';
import { Badge } from 'framework/ui/mui-builder';
import { ChipOwnProps } from '@mui/material';

const STATUS_COLORS: Record<string, ChipOwnProps['color']> = {
  [SKILL_STATUS.CERTIFIED]: 'success',
  [SKILL_STATUS.TRAINING]: 'primary',
};

const SkillStatusBadge = ({ status }: { status: keyof typeof SKILL_STATUS }) => {
  return (
    <Badge
      sx={{
        textTransform: 'capitalize',
      }}
      color={STATUS_COLORS[status as keyof typeof STATUS_COLORS]}
    >
      {SKILL_STATUS_BY_ALIAS[status]}
    </Badge>
  );
};

export default SkillStatusBadge;
